import request from '../_helpers/request';
import axios from 'axios'

export const endProductService = {
    GetCaptions,
    GetByProductId,
    GetListByCompanyId,
    DraftEndProduct,
    SubmitEndProduct,
    DelistEndProduct,
    SyncPIGToFrontEnd

};


async function GetCaptions(langid, categoryid) {
    var query = {
      langId : query,
      categoryId : categoryid
    }
    return await request({
      url: 'EndProduct/GetCaptions',
      method: 'post',
      params: query
    });
}
async function GetByProductId(EndProductId, userid) {
    
    var query = {
      EndProductId : EndProductId,
      LangId : localStorage.getItem("currentLangId"), //[SJP] duplicated param!!!
      action:{
        "LangId": localStorage.getItem("currentLangId")
        , "IP": window.location.host
        , "URL": window.location.href
        , "Referral": document.referrer
        , "BAgent": window.navigator.userAgent
        , "Action" : "GetByProductId"
        , "ActionBy": userid 
      }
    };

    return request.post('EndProduct/GetByProductId', query)
    .then(res => {
        return res;
    });
}
async function GetListByCompanyId(companyId) {
    var query = {
        "LangId": localStorage.getItem("currentLangId")
        , "IP": window.location.host
        , "URL": window.location.href
        , "Referral": document.referrer
        , "BAgent": window.navigator.userAgent
        , "Action" : "GetListByCompanyId"
        , "ActionBy": companyId 
        ,"AccountId":companyId
    };
    return request.post('EndProduct/GetListByCompanyId', query)
    .then(res => {
        return res;
    });

}
async function DraftEndProduct(SaveData, userid) {
    var action = {
      "LangId": localStorage.getItem("currentLangId")
      , "IP": window.location.host
      , "URL": window.location.href
      , "Referral": document.referrer
      , "BAgent": window.navigator.userAgent
      , "Action" : "SaveDraft"
      , "ActionBy" : userid
    };

    var query= {
      endProduct : SaveData,
      action : action,
      ActionBy : userid,
    }

    return request.post('EndProduct/DraftEndProduct', query)
    .then(res => {
        return res;
    });

}
async function SubmitEndProduct(SaveData, userid) {
  var action = {
    "LangId": localStorage.getItem("currentLangId")
    , "IP": window.location.host
    , "URL": window.location.href
    , "Referral": document.referrer
    , "BAgent": window.navigator.userAgent
    , "Action" : "Submit"
    , "ActionBy" : userid
  };
  var query= {
    endProduct : SaveData,
    action : action,
    ActionBy : userid,
  }

  return request.post('EndProduct/SubmitEndProduct', query)
  .then(res => {
      return res;
  });
}
async function DelistEndProduct(endProductId, userid) {
  var action = {
    "LangId": localStorage.getItem("currentLangId")
    , "IP": window.location.host
    , "URL": window.location.href
    , "Referral": document.referrer
    , "BAgent": window.navigator.userAgent
    , "Action" : "Delist"
    , "ActionBy" : userid
  };
  var query = {
    EndProductId : endProductId,
    EmpCompanyId : userid,
    action : action
  }
  return request.post('EndProduct/DelistEndProduct', query)
  .then(res => {
      return res;
  });

}

function SyncPIGToFrontEnd(data) {
  return request({
    url: 'Company/SyncPIGToFrontEnd',
    method: 'post',
    data: data
  });
}